import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FinanceExpenseDialog({ defaultMonth, onClose, onSaved }) {
  const [form, setForm] = useState({
    month: defaultMonth,
    type: 'overhead',
    label: '',
    amount: 0,
    notes: '',
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!form.amount || form.amount <= 0) return toast.error("Montant invalide");
    setSaving(true);
    try {
      await axios.post(`${API}/finance/expenses`, form);
      toast.success("Frais enregistré");
      onSaved(); onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setSaving(false); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="finance-expense-dialog">
        <DialogHeader><DialogTitle>Frais du mois</DialogTitle></DialogHeader>
        <div className="space-y-3 py-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs text-neutral-500">Mois</Label>
              <Input type="month" value={form.month} onChange={(e) => set('month', e.target.value)} data-testid="exp-month" />
            </div>
            <div>
              <Label className="text-xs text-neutral-500">Catégorie</Label>
              <Select value={form.type} onValueChange={(v) => set('type', v)}>
                <SelectTrigger data-testid="exp-type"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="overhead">Frais généraux</SelectItem>
                  <SelectItem value="marketing">Frais marketing</SelectItem>
                  <SelectItem value="consultant_other">Autres frais consulting</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Libellé</Label>
            <Input value={form.label} onChange={(e) => set('label', e.target.value)} placeholder="ex. Loyer, AdWords, sous-traitance…" data-testid="exp-label" />
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Montant</Label>
            <div className="relative">
              <Input type="number" min="0" step="50" value={form.amount} onChange={(e) => set('amount', parseFloat(e.target.value) || 0)} className="pr-8" data-testid="exp-amount" />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 text-sm">€</span>
            </div>
          </div>
          <div>
            <Label className="text-xs text-neutral-500">Notes</Label>
            <Input value={form.notes} onChange={(e) => set('notes', e.target.value)} data-testid="exp-notes" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="exp-save">{saving ? '…' : 'Enregistrer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
